import type { BuildConfig } from './build.types';

function link(rel: string, href: string, as?: string): void {
  const head = document.head;
  if (!head) return;
  for (const existing of Array.from(head.querySelectorAll<HTMLLinkElement>(`link[rel="${rel}"]`))) {
    if (existing.href === href || existing.getAttribute('href') === href) return;
  }
  const element = document.createElement('link');
  element.rel = rel;
  element.href = href;
  element.crossOrigin = 'anonymous';
  if (as) element.setAttribute('as', as);
  head.appendChild(element);
}

/** The API and the CDN, both on the CORS pool the quote, app and translations use. */
export function preconnect(config: BuildConfig): void {
  link('preconnect', config.api);
  link('preconnect', config.cdn);
}

function localeCode(locale: string, codes: string[]): string | undefined {
  if (codes.indexOf(locale) >= 0) return locale;
  const language = locale.split('-')[0].toLowerCase();
  return codes.filter((code) => code.split('-')[0].toLowerCase() === language)[0];
}

/** Starts the translation files for `locale` while the quote is minted. */
export function preloadTranslations(config: BuildConfig, locale: string): void {
  const code = localeCode(locale, config.locales);
  if (!code) return;
  link('preload', `${config.content}/checkout/${code}.json`, 'fetch');
  if (config.noPartners.indexOf(code) < 0) {
    link('preload', `${config.content}/impact_partners/${code}.json`, 'fetch');
  }
}
